import { Platform } from "react-native";

import { IS_TV } from "$src/core/constants/env";

const isUnsupportedTvDevice = () => IS_TV && !Platform.isTV;

export default isUnsupportedTvDevice;
